<template>
  <div class="product">
    <el-row type="flex" justify="between" :gutter="5">
      <el-col :span="isCreate ? 24 : 18">
        <div class="grid-content bg-purple-dark">
          <userCard
            :config="cardConfig"
            :isCreate="isCreate"
            @saveSuccess="getData()"
          ></userCard>
        </div>
      </el-col>
      <el-col :span="6" v-if="!isCreate">
        <div class="enclosure">
          <div class="title flex-between">
            <p>{{ $lange == "en" ? "Annex Library" : "附件库" }}</p>
            <el-input
              size="mini"
              type="text"
              style="width: 150px"
              v-model="fileSearchValue"
              @input="fileSearch"
              :placeholder="
                $lange == 'en' ? 'Please Input' : '请输入标题关键字'
              "
            />
            <el-button size="mini" @click="showDialog">{{
              $lange == "en" ? "Add" : "添加"
            }}</el-button>
          </div>
          <div class="list-box">
            <div
              class="list flex-between"
              v-for="(item, index) in accessoryInfoList"
            >
              <template v-if="item.redName.indexOf(fileSearchValue) > -1">
                <p>{{ renderDate(item.createTime, "yyyy-MM-dd") }}</p>
                <p
                  class="pdf-name row-clip"
                  v-if="item.redName.length > 0"
                  v-html="item.redName"
                >
                  {{ item.redName }}
                </p>
                <p class="pdf-name row-clip" v-else>{{ item.fileName }}</p>
                <div class="btn-group">
                  <el-button
                    type="text"
                    @click="downloadFile(item, item.fileName)"
                    >{{ $lange == "en" ? "Download" : "下载" }}</el-button
                  >
                  <el-button
                    type="text"
                    style="color: red"
                    @click="delFile(item, index)"
                    >{{ $lange == "en" ? "Delete" : "删除" }}</el-button
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <template v-if="!isCreate">
      <el-row type="flex" justify="between" :gutter="5">
        <el-col :span="12">
          <div class="echarts-box">
            <div class="title flex-between">
              <p>{{ $lange == "en" ? "Requests Tracking" : "请求跟踪" }}</p>
              <el-date-picker
                value-format="yyyy"
                v-model="workDate"
                align="right"
                type="year"
                size="mini"
                :placeholder="$lange == 'en' ? 'Please Select Year' : '选择年'"
              ></el-date-picker>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div class="echarts" id="echarts-work"></div>
            </template>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="echarts-box">
            <div class="title flex-between">
              <p>{{ $lange == "en" ? "Cost" : "保修成本跟踪" }}</p>
              <el-date-picker
                value-format="yyyy"
                v-model="costDate"
                align="right"
                type="year"
                size="mini"
                :placeholder="$lange == 'en' ? 'Please Select Year' : '选择年'"
              ></el-date-picker>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div class="echarts" id="echarts-cost"></div>
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="between" :gutter="5">
        <el-col :span="8">
          <div class="echarts-box">
            <div class="title flex-between">
              <p>{{ $lange == "en" ? "Requests Status" : "状态占比" }}</p>
              <el-date-picker
                value-format="yyyy"
                v-model="workPicDate"
                align="right"
                type="year"
                size="mini"
                :placeholder="$lange == 'en' ? 'Please Select Year' : '选择年'"
              ></el-date-picker>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div
                class="echarts"
                id="echarts-work-pie"
                style="padding: 0"
              ></div>
            </template>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="echarts-box">
            <div class="title flex-between">
              <p>{{ $lange == "en" ? "Expenditure" : "成本结构" }}</p>
              <!-- <el-date-picker
                value-format="yyyy"
                v-model="costPicDate"
                align="right"
                type="year"
                size="mini"
                placeholder="选择年"
              ></el-date-picker> -->
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div
                class="echarts"
                id="echarts-cost-pie"
                style="padding: 0"
              ></div>
            </template>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="echarts-box" style="height: 409px; padding-bottom: 15px">
            <div class="title flex-between" style="padding: 12px 20px">
              <p>{{ $lange == "en" ? "Requests by Machine" : "机器问题数" }}</p>
            </div>
            <template v-if="isCreate">
              <div class="not-data flex-between">
                {{ $lange == "en" ? "No Data" : "暂无数据" }}
              </div>
            </template>
            <template v-else>
              <div class="lists">
                <div class="list-title flex-between">
                  <p>{{ $lange == "en" ? "Ranking" : "排名" }}</p>
                  <p class="list-child-wid">
                    {{ $lange == "en" ? "Machine" : "机器" }}
                  </p>
                  <p>{{ $lange == "en" ? "Number of Request" : "请求次数" }}</p>
                </div>
                <template
                  v-if="
                    productData.machineProblemList &&
                    productData.machineProblemList.length > 0
                  "
                >
                  <div
                    class="list-context flex-between"
                    v-for="(item, idx) in productData.machineProblemList"
                  >
                    <p>{{ idx + 1 }}</p>
                    <p
                      class="row-clip list-child-wid row-clip"
                      :title="item.machineName"
                    >
                      {{ item.machineName }}
                    </p>
                    <p class="list-progress flex-between">
                      <span>{{ item.number }}</span>
                      <el-progress
                        :percentage="
                          productData.machineProblemListTotal == 0
                            ? 0
                            : (item.number /
                                productData.machineProblemListTotal) *
                              100
                        "
                        :show-text="false"
                      ></el-progress>
                    </p>
                  </div>
                </template>
                <div class="list-context flex-between" v-else>
                  <!-- <p style="opacity: 0">0</p> -->
                  <p
                    class="row-clip list-child-wid row-clip data_null"
                    :title="$lange == 'en' ? 'No Data' : '暂无数据' "
                  >
                    {{ $lange == "en" ? "No Data" : "暂无数据" }}
                  </p>
                  <!-- <p class="list-progress flex-between" style="opacity: 0">
                    <span>0</span>
                    <el-progress
                      :percentage="0"
                      :show-text="false"
                    ></el-progress>
                  </p> -->
                </div>
              </div>
            </template>
          </div>
        </el-col>
      </el-row>
      <div class="table-box">
        <div class="table-title flex-between">
          <div class="left">
            <div class="label">
              {{
                $lange == "en" ? "Customer Product Description" : "客户产品详情"
              }}
            </div>
          </div>
          <el-button
            :icon="historyTableShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            class="show-btn"
            size="mini"
            @click="showTable('historyTableShow')"
            >{{ historyTableShow ? "收起" : "展开" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div class="table-content" v-show="historyTableShow">
            <cc-table
              :config="historyTableConfig"
              :params="historyTableParams"
              :load-data="historyTableParams.jobId.length > 0"
            ></cc-table>
          </div>
        </el-collapse-transition>
      </div>
    </template>

    <el-dialog
      :title="$lange == 'en' ? 'Add Annex' : '添加附件'"
      :visible.sync="dialogFlag"
      width="60%"
      append-to-body
    >
      <el-form ref="form" :model="accessory" label-width="80px">
        <el-form-item
          :label="$lange == 'en' ? 'Annex Name' : '附件名'"
          required="true"
        >
          <el-input v-model="accessory.fileName"></el-input>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Upload' : '文件上传'"
          required="true"
          style="line-height: 0"
        >
          <cc-uploader
            :config="uploaderConf2"
            v-model="accessory.accessoryUrl"
            @get-file="getFile"
          />
        </el-form-item>

        <el-button type="primary" size="mini" @click="postFile">{{
          $lange == "en" ? "Save" : "保存"
        }}</el-button>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="detailsDialog"
      :fullscreen="true"
      :title="$lange == 'en' ? 'Details' : '详情'"
      append-to-body
    >
      <template v-if="detailsDialog">
        <OrderDescriptionView
          :orderIdV2="detailsId"
          :isDialog="true"
        ></OrderDescriptionView>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import UserCard from "../../../components/UserCard";
import Echarts from "echarts";
import moment from "moment";
import axios from "axios";
import utils from "../../../utils/utils";
import API from "../../../../src/api/api-config.js";
import OrderDescriptionView from "../../order/OrderDescription.vue";

export default {
  name: "ProductComponent",
  props: {
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    workDate: {
      handler() {
        this.workInit();
      },
    },
    workPicDate: {
      handler() {
        this.workPieInit();
      },
    },
    costDate: {
      handler() {
        this.costInit();
      },
    },
    costPicDate: {
      handler() {
        this.costPieInit();
      },
    },
  },
  data() {
    return {
      detailsDialog: false,
      detailsId: "",
      accessory: {
        fileName: "",
        accessoryUrl: "",
      },
      dialogFlag: false,
      enclosureSearch: "",
      cardConfig: {
        id: "",
        api: "admin/fsb/product/save",
        image: "",
        isProduct: true,
        jobId: null,
        productAddress: null,
        formLists: [
          //表单内容
          {
            key: "customerId",
            name: "客户",
            value: "",
            type: "select",
            placeholder: "请选择客户",
            required: true,
          },
          {
            name: "FAS",
            type: "input",
            value: "",
            disabled: true,
            key: "fasId",
          },
          {
            name: "项目经理",
            type: "input",
            value: "",
            disabled: true,
            key: "managerName",
          },
          {
            name: "产品线",
            value: "",
            type: "constant-select",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
            required: true,
            key: "productLine",
          },
          {
            name: "速度",
            value: "",
            type: "constant-select",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
            key: "speed",
          },
          {
            name: "幅宽",
            value: "",
            type: "constant-select",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
            key: "breadth",
          },
          {
            name: "堆叠层数",
            value: "",
            type: "constant-select",
            key: "stackedLayers",
          },
          {
            name: "瓦楞层数",
            value: "",
            type: "constant-select",
            key: "corrugatedLayers",
          },
          {
            name: "保修时间",
            value: "",
            type: "daterange",
            required: true,
            key: "warrantyTime",
          },
          {
            name: "开机时间",
            value: "",
            type: "datetime", //想去掉时分秒的话，这里变成 date 就可以了
            key: "bootTime",
          },
        ],
        requiredList: {
          warrantyTime: true,
        },
        postKey: [
          "customerId",
          "productLine",
          "speed",
          "breadth",
          "stackedLayers",
          "corrugatedLayers",
          "warrantyTime",
          "bootTime",
        ],
      },
      productData: {},
      workDate: "", //工单请求情况 柱状图 日期
      workPicDate: "", //工单请求情况 圆饼图 日期
      costDate: "",
      costPicDate: "",
      historyTableShow: false,
      historyTableParams: {
        jobId: "",
        pageSize: 999,
      },
      historyTableConfig: {
        api: "admin/fsb/work/order/query",
        showPager: false,
        // dragState: true,
        columns: [
          {
            prop: "id",
            lable: "Care ID",
          },
          {
            prop: "jobId",
            lable: "Job ID",
          },
          {
            prop: "priority",
            lable: "Priority",
          },
          {
            prop: "product.status",
            lable: "ProductStatus",
            // type: "tag",
            // options: [
            //   { tagType: "info", text: "新增" },
            //   { tagType: "warning", text: "安装" },
            //   { tagType: "success", text: "保内" },
            //   { tagType: "danger", text: "保外" },
            // ],
            type: "constant",
            constantConfig: {
              code: "productStatus",
              api: "admin/dict/pageTree",
              opts: { 0: "info", 1: "warning", 2: "success", 3: "danger" },
            },
            minWidth: this.$lange == "en" ? 130 : 80,
          },

          {
            prop: "customer.customerName",
            lable: "Customer",
          },
          {
            prop: "handlerName",
            lable: "Contact",
          },
          {
            prop: "machine.machineModel",
            lable: "Machine",
          },
          {
            prop: "machine.fiCom",
            lable: "COM",
          },
          {
            prop: "title",
            lable: "Subject",
          },
          {
            prop: "userName",
            lable: "CareManager",
          },
          {
            prop: "status",
            lable: "Status",
            type: "constant",
            constantConfig: {
              code: "orderStatus",
              api: "admin/dict/pageTree",
              opts: {
                0: "info",
                1: "warning",
                2: "warning",
                3: "success",
                4: "success",
                5: "info",
              },
            },
          },
          {
            prop: "malfunctionAttribute.name",
            lable: "Classification",
          },
          {
            lable: "Last update",
            render: (row) => {
              return moment(row.updateTime).format("YYYY-MM-DD");
            },
          },
          {
            lable: "Created",
            render: (row) => {
              return moment(row.createTime).format("YYYY-MM-DD");
            },
          },
        ],
        buttons: [
          {
            name: "详情",
            click: (row) => {
              this.detailsId = row.id;
              this.detailsDialog = true;
              // this.$router.push({
              //   path: "/admin/order/des",
              //   query: {
              //     id: row.id,
              //   },
              // });
            },
          },
        ],
      },
      uploaderConf2: this.$uploadUtils.config,
      productId: "",
      fileSearchValue: "",
      accessoryInfoList: [],
      file: {},
    };
  },
  methods: {
    getFile(e) {
      this.file = { ...e };
      //   console.log(e, "eeeeeeeeeeee");
    },
    fileSearch(res) {
      for (let i in this.accessoryInfoList) {
        this.accessoryInfoList[i].redName = "";
        if (this.accessoryInfoList[i].fileName.indexOf(res) > -1) {
          this.accessoryInfoList[i].redName = this.accessoryInfoList[
            i
          ].fileName.replace(res, `<span style="color: red">${res}</span>`);
        }
      }
    },
    renderDate(date, format) {
      date = new Date(date);
      let res = utils.getFormatDate(date, format);
      return res;
    },

    downloadFile(data, name) {
      if (data.accessoryUrl.length < 1) {
        return this.$message({
          type: "warning",
          message: "文件错误,请重新上传",
        });
      }
      if (data.fileName.indexOf("pdf") > -1) {
        let pData = {
          url: data.accessoryUrl,
        };
        return this.ccRequest
          .do("admin/fsb/file/aliyun/privateDownloadUrl", pData, "GET")
          .then((res) => {
            axios({
              method: "get",
              url: res.url,
              headers: {
                "Content-Disposition": "attachment",
              },
            }).then((res2) => {
              this.$message({
                type: "success",
                message: "文件已下载",
              });
            });
          });
      }

      this.$message({
        type: "success",
        message: "文件已下载",
      });
      let imageType = ["png", "jpg", "jpeg", "webp"];
      for (let i in imageType) {
        if (data.fileName.indexOf(imageType[i]) > -1) {
          this.downloadImage(data.accessoryUrl, name);
          return false;
        }
      }
      let a = document.createElement("a");
      a.href = data.accessoryUrl;
      a.download = name;
      a.click();
    },
    downloadImage(imgsrc, name) {
      // 下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    delFile(item, index) {
      this.$confirm("此操作会删除该附件, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            id: item.id,
          };
          this.ccRequest
            .do("admin/fsb/accessory/delete", data, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.accessoryInfoList.splice(index, 1);
              this.getProduct();
            });
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    postFile() {
      let data = this.accessory;
      data.objId = this.cardConfig.jobId;
      data.objType = "product";
      if (data.fileName.length < 1) {
        this.$message({
          message: "请输入文件名",
          type: "warning",
        });
        return false;
      }
      if (data.accessoryUrl.length < 1) {
        this.$message({
          message: "请上传附件",
          type: "warning",
        });
        return false;
      }

      if (this.file.file) {
        let nameArray = this.file.file.name.split(".");
        data.fileName = data.fileName + "." + nameArray[1];
      }
      // console.log(data, this.file);
      this.ccRequest
        .do("admin/fsb/accessory/save", data, "POSTJSON")
        .then((res) => {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.dialogFlag = false;
          this.getProduct();
          this.accessory = {
            fileName: "",
            accessoryUrl: "",
          };
        })
        .catch((res) => {
          this.$message.error(res.response.data.message);
        });
    },
    getProduct() {
      let data = {
        id: this.productId,
      };
      this.ccRequest.do("admin/fsb/product/get", data, "GET").then((res) => {
        for (let j in this.cardConfig.formLists) {
          for (let i in res) {
            // console.log(this.cardConfig.formLists[j].key, "aaa", i, "bbb")
            if (
              this.cardConfig.formLists[j].key &&
              this.cardConfig.formLists[j].key == i
            ) {
              if (this.cardConfig.formLists[j].key == "customerId") {
                if (res.customer) {
                  this.cardConfig.formLists[j].value =
                    res.customer.customerName;
                  this.cardConfig.formLists[j].customerId = res.customer.id;
                }
              } else {
                this.cardConfig.formLists[j].value = res[i];
              }
            }
          }
          this.historyTableParams.jobId = res.jobId;
        }
        for (let i in res.accessoryInfoList) {
          res.accessoryInfoList[i].redName = "";
        }
        this.cardConfig.jobId = res.jobId;
        this.cardConfig.image = res.imageUrl;
        this.cardConfig.productAddress = res.productAddress;
        this.accessoryInfoList = res.accessoryInfoList;
        res.machineProblemListTotal = 0;
        for (let i in res.machineProblemList) {
          res.machineProblemListTotal += res.machineProblemList[i].number;
        }
        this.productData = res;
        this.initEcharts();
      });
    },

    showDialog() {
      if (this.isCreate) {
        this.$message({
          type: "warning",
          message: "产品未创建不可添加附件",
        });
        return false;
      }
      this.dialogFlag = true;
    },
    getData() {
      this.getProduct();
    },
    save(isCreate = false) {
      console.log(isCreate);
      console.log(this.cardConfig);
      // let url = ''
      // this.ccRequest.do("")
    },
    showTable(tableType) {
      if (this.isCreate) {
        this.$alert("客户未创建，暂无数据", "温馨提示");
        return false;
      }
      this[tableType] = !this[tableType];
    },
    workInit() {
      let data = {
        jobId: this.cardConfig.jobId,
        // jobId: "1113产品",
        year: this.workDate,
      };
      this.ccRequest
        .do("admin/fsb/product/workOrderSituation", data, "GET")
        .then((res) => {
          let value = [];
          for (let j = 0; j < 12; j++) {
            //初始化12个月的值
            value.push(0);
          }
          for (let i in res) {
            value[res[i].month - 1] = res[i].count;
          }
          console.log(value);
          let option = {
            color: ["#49a9ee"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: [
                  "1月",
                  "2月",
                  "3月",
                  "4月",
                  "5月",
                  "6月",
                  "7月",
                  "8月",
                  "9月",
                  "10月",
                  "11月",
                  "12月",
                ],
                axisTick: {
                  alignWithLabel: true,
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "次数(单位次)",
              },
            ],
            series: [
              {
                name: "工单请求数",
                type: "bar",
                barWidth: "20%",
                data: value,
              },
            ],
          };
          let workCanvas = Echarts.init(
            document.getElementById("echarts-work")
          );
          workCanvas.setOption(option);
        });
    },
    workPieInit() {
      let data = {
        jobId: this.cardConfig.jobId,
        // jobId: "1113产品",
        year: this.workPicDate,
      };
      this.ccRequest
        .do("admin/fsb/product/workOrderStatus", data, "GET")
        .then((res) => {
          let option = {
            tooltip: {
              trigger: "item",
              /**
               * @b name
               * @c value
               * @d angle
               * */
              formatter: "{b} : {c} ({d}%)",
            },
            series: [
              {
                type: "pie",
                radius: "55%",
                center: ["50%", "50%"],
                data: [
                  {
                    value: res.unprocessed,
                    name: "未处理",
                    label: {
                      formatter: "{b} : {c}",
                    },
                    itemStyle: {
                      color: "#81d3f8",
                    },
                  },
                  {
                    value: res.processing,
                    name: `处理中`,
                    label: {
                      formatter: "{b} : {c}",
                    },
                    itemStyle: {
                      color: "#49a9ee",
                    },
                  },
                  {
                    value: res.solved,
                    name: `已解决`,
                    label: {
                      formatter: "{b} : {c}",
                    },
                    itemStyle: {
                      color: "#e6c163",
                    },
                  },
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          let workPicCanvas = Echarts.init(
            document.getElementById("echarts-work-pie")
          );
          workPicCanvas.setOption(option);
        });
    },
    costPieInit() {
      let data = {
        productId: this.productId,
        // year: this.costPicDate,
      };
      this.ccRequest
        .do("admin/fsb/product/insuranceExpenditure", data, "GET")
        .then((res) => {
          console.log(res, "成本结构");
          let option = {
            tooltip: {
              trigger: "item",
              /**
               * @b name
               * @c value
               * @d angle
               * */
              formatter: "{b} : {c} ({d}%)",
            },
            series: [
              {
                type: "pie",
                radius: "55%",
                center: ["50%", "50%"],
                data: [
                  {
                    value: res.otherFee / 100 || 0,
                    name: "其他总计",
                    label: {
                      formatter: "占比{d}% \n\n {b}: {c}",
                    },
                    itemStyle: {
                      color: "#81d3f8",
                    },
                  },
                  {
                    value: res.partsFee / 100 || 0,
                    name: `配件费用总计`,
                    label: {
                      formatter: "占比{d}% \n\n {b}: {c}",
                    },
                    itemStyle: {
                      color: "#49a9ee",
                    },
                  },
                  {
                    value: res.serviceFee / 100 || 0,
                    name: `人工费用总计`,
                    label: {
                      formatter: "占比{d}% \n\n {b}: {c}",
                    },
                    itemStyle: {
                      color: "#e6c163",
                    },
                  },
                  {
                    value: res.travelFee / 100 || 0,
                    name: `差旅费用总计`,
                    label: {
                      formatter: "占比{d}% \n\n {b}: {c}",
                    },
                    itemStyle: {
                      color: "#70b603",
                    },
                  },
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          let costPicCanvas = Echarts.init(
            document.getElementById("echarts-cost-pie")
          );
          costPicCanvas.setOption(option);
        });
    },
    costInit() {
      let data = {
        productId: this.productId,
        year: this.costDate,
      };
      this.ccRequest
        .do("admin/fsb/product/insuredCost", data, "GET")
        .then((res) => {
          let source = [
            ["product", "配件费用", "服务费用", "差旅费用", "其他费用"],
            ["第一季度", 0, 0, 0, 0],
            ["第二季度", 0, 0, 0, 0],
            ["第三季度", 0, 0, 0, 0],
            ["第四季度", 0, 0, 0, 0],
          ];
          for (let i in res) {
            let item = res[i];
            source[item.quarter] = [
              source[item.quarter][0],
              item.partsFee / 100,
              item.serviceFee / 100,
              item.travelFee / 100,
              item.otherFee / 100,
            ];
          }
          let option = {
            legend: {},
            tooltip: {},
            dataset: {
              source: source,
              itemStyle: {},
            },
            xAxis: { type: "category" },
            yAxis: {},
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [
              { type: "bar", color: "#d9001b", barWidth: "25px" },
              { type: "bar", color: "#49a9ee", barWidth: "25px" },
              { type: "bar", color: "#facd91", barWidth: "25px" },
              { type: "bar", color: "#555555", barWidth: "25px" },
            ],
          };
          let costCanvas = Echarts.init(
            document.getElementById("echarts-cost")
          );
          costCanvas.setOption(option);
        });
    },
    initEcharts() {
      //如果是创建页面, 无需实例化图标
      if (this.isCreate) {
        return false;
      }
      let year = `${new Date().getFullYear()}`;
      this.workDate = year;
      this.workPicDate = year;
      this.costDate = year;
      this.costPicDate = year;
    },
    checkLanguage() {
      if (this.$lange == "en") {
        this.cardConfig.formLists = [
          //表单内容
          {
            key: "customerId",
            name: "Customer Name",
            value: "",
            type: "select",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
          },
          {
            name: "FAS",
            type: "input",
            value: "",
            disabled: true,
            key: "fasId",
          },
          {
            name: "Project Manager",
            type: "input",
            value: "",
            disabled: true,
            key: "managerName",
          },
          {
            name: "Product Line",
            value: "",
            type: "constant-select",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
            key: "productLine",
          },
          {
            name: "Speed",
            value: "",
            type: "constant-select",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
            key: "speed",
          },
          {
            name: "Width",
            value: "",
            type: "constant-select",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
            key: "breadth",
          },
          {
            name: "Staker Level",
            value: "",
            type: "constant-select",
            key: "stackedLayers",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
          },
          {
            name: "Flutes",
            value: "",
            type: "constant-select",
            key: "corrugatedLayers",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
          },
          {
            name: "Start end",
            value: "",
            type: "daterange",
            key: "warrantyTime",
            placeholder: this.$lange == "en" ? "Please Select" : "请输入",
          },
        ];
      }
    },
  },
  mounted() {
    this.checkLanguage();
    if (this.isCreate) {
      console.log("create");
      return false;
    }
    this.productId = this.$route.query.productId;
    this.cardConfig.id = this.productId;

    this.getData();
  },
  components: {
    UserCard,
    OrderDescriptionView,
  },
};
</script>
<style >
.product .el-dialog__body {
  padding: 10px 20px 30px 20px;
}
</style>
<style scoped lang="scss">
.product {
  .title {
    font-size: 18px;
    font-weight: bolder;
    color: #6f6f6f;
  }
  .table-box {
    background: #ffffff;
    margin-top: 5px;

    .table-title {
      padding: 10px 20px;

      .left {
        display: flex;
        align-items: center;

        .add-contacts {
          font-size: 12px;
          padding: 5px;
          margin-left: 15px;
        }
      }

      .show-btn {
        font-size: 12px;
        background: #e4e4e4;
        padding: 3px 10px;
        cursor: pointer;
      }
    }
  }

  .enclosure {
    height: 100%;
    max-height: 397px;
    background: #ffffff;
    padding: 10px 20px;
    box-sizing: border-box;
    overflow-y: scroll;

    .list-box {
      display: flex;
      flex-direction: column;
      .list {
        margin-top: 10px;
        .pdf-name {
          width: 120px;
        }
        img {
          display: block;
          width: 30px;
        }
      }
    }
  }
  .echarts-box {
    margin-top: 5px;
    background: #ffffff;
    box-sizing: border-box;
    /*标题*/
    .title {
      border-bottom: 1px solid #e4e4e4;
      padding: 10px 20px;
    }
    /*图表*/
    .echarts {
      padding: 20px;
      height: 360px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
    }
    /*表格内容*/
    .lists {
      height: 345px;
      overflow: auto;
      padding: 0 20px;
      p {
        min-width: 80px;
      }

      & > * > p {
        padding: 10px 0;
        &:last-child {
          flex: 1;
        }
        &:first-child {
          text-align: center;
        }
        &:nth-child(2) {
          margin: 0 10px;
        }
      }
      .list-child-wid {
        width: 120px;
      }
      .list-title {
        color: #cccccc;
        border-bottom: 1px solid #e4e4e4;
      }
      .list-context {
        &:not(:last-child) {
          border-bottom: 1px solid #e4e4e4;
        }
        .list-progress {
          span {
            margin-right: 10px;
          }
        }
      }
    }
    /*无数据的时候显示*/
    .not-data {
      height: 360px;
      justify-content: center;
      font-size: 22px;
      color: #e4e4e4;
    }
  }
}
.data_null {
  margin-top: 30px;
  color: #909399;
}
</style>
